//#region node_modules/.deno/ts-pattern@5.8.0/node_modules/ts-pattern/dist/index.js
const t = Symbol.for("@ts-pattern/matcher"), e = Symbol.for("@ts-pattern/isVariadic"), n = "@ts-pattern/anonymous-select-key", r = (t$1) => Boolean(t$1 && "object" == typeof t$1), i = (e$1) => e$1 && !!e$1[t], o = (n$1, s$1, c$1) => {
	if (i(n$1)) {
		const e$1 = n$1[t](), { matched: r$1, selections: i$1 } = e$1.match(s$1);
		return r$1 && i$1 && Object.keys(i$1).forEach((t$1) => c$1(t$1, i$1[t$1])), r$1;
	}
	if (r(n$1)) {
		if (!r(s$1)) return !1;
		if (Array.isArray(n$1)) {
			if (!Array.isArray(s$1)) return !1;
			let t$1 = [], r$1 = [], a$1 = [];
			for (const o$1 of n$1.keys()) {
				const s$2 = n$1[o$1];
				i(s$2) && s$2[e] ? a$1.push(s$2) : a$1.length ? r$1.push(s$2) : t$1.push(s$2);
			}
			if (a$1.length) {
				if (a$1.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
				if (s$1.length < t$1.length + r$1.length) return !1;
				const e$1 = s$1.slice(0, t$1.length), n$2 = 0 === r$1.length ? [] : s$1.slice(-r$1.length), i$1 = s$1.slice(t$1.length, 0 === r$1.length ? Infinity : -r$1.length);
				return t$1.every((t$2, n$3) => o(t$2, e$1[n$3], c$1)) && r$1.every((t$2, e$2) => o(t$2, n$2[e$2], c$1)) && (0 === a$1.length || o(a$1[0], i$1, c$1));
			}
			return n$1.length === s$1.length && n$1.every((t$2, e$1) => o(t$2, s$1[e$1], c$1));
		}
		return Reflect.ownKeys(n$1).every((e$1) => {
			const r$1 = n$1[e$1];
			return (e$1 in s$1 || i(a$1 = r$1) && "optional" === a$1[t]().matcherType) && o(r$1, s$1[e$1], c$1);
			var a$1;
		});
	}
	return Object.is(s$1, n$1);
}, s = (e$1) => {
	var n$1, o$1, a$1;
	return r(e$1) ? i(e$1) ? null != (n$1 = null == (o$1 = (a$1 = e$1[t]()).getSelectionKeys) ? void 0 : o$1.call(a$1)) ? n$1 : [] : Array.isArray(e$1) ? c(e$1, s) : c(Object.values(e$1), s) : [];
}, c = (t$1, e$1) => t$1.reduce((t$2, n$1) => t$2.concat(e$1(n$1)), []);
function a(...t$1) {
	if (1 === t$1.length) {
		const [e$1] = t$1;
		return (t$2) => o(e$1, t$2, () => {});
	}
	if (2 === t$1.length) {
		const [e$1, n$1] = t$1;
		return o(e$1, n$1, () => {});
	}
	throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t$1.length}.`);
}
function u(t$1) {
	return Object.assign(t$1, {
		optional: () => l(t$1),
		and: (e$1) => m(t$1, e$1),
		or: (e$1) => d(t$1, e$1),
		select: (e$1) => void 0 === e$1 ? y(t$1) : y(e$1, t$1)
	});
}
function h(t$1) {
	return Object.assign(((t$2) => Object.assign(t$2, { [Symbol.iterator]() {
		let n$1 = 0;
		const r$1 = [{
			value: Object.assign(t$2, { [e]: !0 }),
			done: !1
		}, {
			done: !0,
			value: void 0
		}];
		return { next: () => {
			var t$3;
			return null != (t$3 = r$1[n$1++]) ? t$3 : r$1.at(-1);
		} };
	} }))(t$1), {
		optional: () => h(l(t$1)),
		select: (e$1) => h(void 0 === e$1 ? y(t$1) : y(e$1, t$1))
	});
}
function l(e$1) {
	return u({ [t]: () => ({
		match: (t$1) => {
			let n$1 = {};
			const r$1 = (t$2, e$2) => {
				n$1[t$2] = e$2;
			};
			return void 0 === t$1 ? (s(e$1).forEach((t$2) => r$1(t$2, void 0)), {
				matched: !0,
				selections: n$1
			}) : {
				matched: o(e$1, t$1, r$1),
				selections: n$1
			};
		},
		getSelectionKeys: () => s(e$1),
		matcherType: "optional"
	}) });
}
const f = (t$1, e$1) => {
	for (const n$1 of t$1) if (!e$1(n$1)) return !1;
	return !0;
}, g = (t$1, e$1) => {
	for (const [n$1, r$1] of t$1.entries()) if (!e$1(r$1, n$1)) return !1;
	return !0;
};
function m(...e$1) {
	return u({ [t]: () => ({
		match: (t$1) => {
			let n$1 = {};
			const r$1 = (t$2, e$2) => {
				n$1[t$2] = e$2;
			};
			return {
				matched: e$1.every((e$2) => o(e$2, t$1, r$1)),
				selections: n$1
			};
		},
		getSelectionKeys: () => c(e$1, s),
		matcherType: "and"
	}) });
}
function d(...e$1) {
	return u({ [t]: () => ({
		match: (t$1) => {
			let n$1 = {};
			const r$1 = (t$2, e$2) => {
				n$1[t$2] = e$2;
			};
			return c(e$1, s).forEach((t$2) => r$1(t$2, void 0)), {
				matched: e$1.some((e$2) => o(e$2, t$1, r$1)),
				selections: n$1
			};
		},
		getSelectionKeys: () => c(e$1, s),
		matcherType: "or"
	}) });
}
function p(e$1) {
	return { [t]: () => ({ match: (t$1) => ({ matched: Boolean(e$1(t$1)) }) }) };
}
function y(...e$1) {
	const r$1 = "string" == typeof e$1[0] ? e$1[0] : void 0, i$1 = 2 === e$1.length ? e$1[1] : "string" == typeof e$1[0] ? void 0 : e$1[0];
	return u({ [t]: () => ({
		match: (t$1) => {
			let e$2 = { [null != r$1 ? r$1 : n]: t$1 };
			return {
				matched: void 0 === i$1 || o(i$1, t$1, (t$2, n$1) => {
					e$2[t$2] = n$1;
				}),
				selections: e$2
			};
		},
		getSelectionKeys: () => [null != r$1 ? r$1 : n].concat(void 0 === i$1 ? [] : s(i$1))
	}) });
}
function v(t$1) {
	return "number" == typeof t$1;
}
function b(t$1) {
	return "string" == typeof t$1;
}
function w(t$1) {
	return "bigint" == typeof t$1;
}
const S = u(p(function(t$1) {
	return !0;
})), O = S, j = (t$1) => Object.assign(u(t$1), {
	startsWith: (e$1) => {
		return j(m(t$1, (n$1 = e$1, p((t$2) => b(t$2) && t$2.startsWith(n$1)))));
		var n$1;
	},
	endsWith: (e$1) => {
		return j(m(t$1, (n$1 = e$1, p((t$2) => b(t$2) && t$2.endsWith(n$1)))));
		var n$1;
	},
	minLength: (e$1) => j(m(t$1, ((t$2) => p((e$2) => b(e$2) && e$2.length >= t$2))(e$1))),
	length: (e$1) => j(m(t$1, ((t$2) => p((e$2) => b(e$2) && e$2.length === t$2))(e$1))),
	maxLength: (e$1) => j(m(t$1, ((t$2) => p((e$2) => b(e$2) && e$2.length <= t$2))(e$1))),
	includes: (e$1) => {
		return j(m(t$1, (n$1 = e$1, p((t$2) => b(t$2) && t$2.includes(n$1)))));
		var n$1;
	},
	regex: (e$1) => {
		return j(m(t$1, (n$1 = e$1, p((t$2) => b(t$2) && Boolean(t$2.match(n$1))))));
		var n$1;
	}
}), K = j(p(b)), x = (t$1) => Object.assign(u(t$1), {
	between: (e$1, n$1) => x(m(t$1, ((t$2, e$2) => p((n$2) => v(n$2) && t$2 <= n$2 && e$2 >= n$2))(e$1, n$1))),
	lt: (e$1) => x(m(t$1, ((t$2) => p((e$2) => v(e$2) && e$2 < t$2))(e$1))),
	gt: (e$1) => x(m(t$1, ((t$2) => p((e$2) => v(e$2) && e$2 > t$2))(e$1))),
	lte: (e$1) => x(m(t$1, ((t$2) => p((e$2) => v(e$2) && e$2 <= t$2))(e$1))),
	gte: (e$1) => x(m(t$1, ((t$2) => p((e$2) => v(e$2) && e$2 >= t$2))(e$1))),
	int: () => x(m(t$1, p((t$2) => v(t$2) && Number.isInteger(t$2)))),
	finite: () => x(m(t$1, p((t$2) => v(t$2) && Number.isFinite(t$2)))),
	positive: () => x(m(t$1, p((t$2) => v(t$2) && t$2 > 0))),
	negative: () => x(m(t$1, p((t$2) => v(t$2) && t$2 < 0)))
}), E = x(p(v)), A = (t$1) => Object.assign(u(t$1), {
	between: (e$1, n$1) => A(m(t$1, ((t$2, e$2) => p((n$2) => w(n$2) && t$2 <= n$2 && e$2 >= n$2))(e$1, n$1))),
	lt: (e$1) => A(m(t$1, ((t$2) => p((e$2) => w(e$2) && e$2 < t$2))(e$1))),
	gt: (e$1) => A(m(t$1, ((t$2) => p((e$2) => w(e$2) && e$2 > t$2))(e$1))),
	lte: (e$1) => A(m(t$1, ((t$2) => p((e$2) => w(e$2) && e$2 <= t$2))(e$1))),
	gte: (e$1) => A(m(t$1, ((t$2) => p((e$2) => w(e$2) && e$2 >= t$2))(e$1))),
	positive: () => A(m(t$1, p((t$2) => w(t$2) && t$2 > 0))),
	negative: () => A(m(t$1, p((t$2) => w(t$2) && t$2 < 0)))
}), P = A(p(w)), T = u(p(function(t$1) {
	return "boolean" == typeof t$1;
})), B = u(p(function(t$1) {
	return "symbol" == typeof t$1;
})), _ = u(p(function(t$1) {
	return null == t$1;
})), k = u(p(function(t$1) {
	return null != t$1;
}));
var N = {
	__proto__: null,
	matcher: t,
	optional: l,
	array: function(...e$1) {
		return h({ [t]: () => ({
			match: (t$1) => {
				if (!Array.isArray(t$1)) return { matched: !1 };
				if (0 === e$1.length) return { matched: !0 };
				const n$1 = e$1[0];
				let r$1 = {};
				if (0 === t$1.length) return s(n$1).forEach((t$2) => {
					r$1[t$2] = [];
				}), {
					matched: !0,
					selections: r$1
				};
				const i$1 = (t$2, e$2) => {
					r$1[t$2] = (r$1[t$2] || []).concat([e$2]);
				};
				return {
					matched: t$1.every((t$2) => o(n$1, t$2, i$1)),
					selections: r$1
				};
			},
			getSelectionKeys: () => 0 === e$1.length ? [] : s(e$1[0])
		}) });
	},
	set: function(...e$1) {
		return u({ [t]: () => ({
			match: (t$1) => {
				if (!(t$1 instanceof Set)) return { matched: !1 };
				let n$1 = {};
				if (0 === t$1.size) return {
					matched: !0,
					selections: n$1
				};
				if (0 === e$1.length) return { matched: !0 };
				const r$1 = (t$2, e$2) => {
					n$1[t$2] = (n$1[t$2] || []).concat([e$2]);
				}, i$1 = e$1[0];
				return {
					matched: f(t$1, (t$2) => o(i$1, t$2, r$1)),
					selections: n$1
				};
			},
			getSelectionKeys: () => 0 === e$1.length ? [] : s(e$1[0])
		}) });
	},
	map: function(...e$1) {
		return u({ [t]: () => ({
			match: (t$1) => {
				if (!(t$1 instanceof Map)) return { matched: !1 };
				let n$1 = {};
				if (0 === t$1.size) return {
					matched: !0,
					selections: n$1
				};
				const r$1 = (t$2, e$2) => {
					n$1[t$2] = (n$1[t$2] || []).concat([e$2]);
				};
				if (0 === e$1.length) return { matched: !0 };
				var i$1;
				if (1 === e$1.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i$1 = e$1[0]) ? void 0 : i$1.toString()}`);
				const [s$1, c$1] = e$1;
				return {
					matched: g(t$1, (t$2, e$2) => {
						const n$2 = o(s$1, e$2, r$1), i$2 = o(c$1, t$2, r$1);
						return n$2 && i$2;
					}),
					selections: n$1
				};
			},
			getSelectionKeys: () => 0 === e$1.length ? [] : [...s(e$1[0]), ...s(e$1[1])]
		}) });
	},
	intersection: m,
	union: d,
	not: function(e$1) {
		return u({ [t]: () => ({
			match: (t$1) => ({ matched: !o(e$1, t$1, () => {}) }),
			getSelectionKeys: () => [],
			matcherType: "not"
		}) });
	},
	when: p,
	select: y,
	any: S,
	_: O,
	string: K,
	number: E,
	bigint: P,
	boolean: T,
	symbol: B,
	nullish: _,
	nonNullable: k,
	instanceOf: function(t$1) {
		return u(p(function(t$2) {
			return (e$1) => e$1 instanceof t$2;
		}(t$1)));
	},
	shape: function(t$1) {
		return u(p(a(t$1)));
	}
};
var W = class extends Error {
	constructor(t$1) {
		let e$1;
		try {
			e$1 = JSON.stringify(t$1);
		} catch (n$1) {
			e$1 = t$1;
		}
		super(`Pattern matching error: no pattern matches value ${e$1}`), this.input = void 0, this.input = t$1;
	}
};
const $ = {
	matched: !1,
	value: void 0
};
function z(t$1) {
	return new I(t$1, $);
}
var I = class I {
	constructor(t$1, e$1) {
		this.input = void 0, this.state = void 0, this.input = t$1, this.state = e$1;
	}
	with(...t$1) {
		if (this.state.matched) return this;
		const e$1 = t$1[t$1.length - 1], r$1 = [t$1[0]];
		let i$1;
		3 === t$1.length && "function" == typeof t$1[1] ? i$1 = t$1[1] : t$1.length > 2 && r$1.push(...t$1.slice(1, t$1.length - 1));
		let s$1 = !1, c$1 = {};
		const a$1 = (t$2, e$2) => {
			s$1 = !0, c$1[t$2] = e$2;
		}, u$1 = !r$1.some((t$2) => o(t$2, this.input, a$1)) || i$1 && !Boolean(i$1(this.input)) ? $ : {
			matched: !0,
			value: e$1(s$1 ? n in c$1 ? c$1[n] : c$1 : this.input, this.input)
		};
		return new I(this.input, u$1);
	}
	when(t$1, e$1) {
		if (this.state.matched) return this;
		const n$1 = Boolean(t$1(this.input));
		return new I(this.input, n$1 ? {
			matched: !0,
			value: e$1(this.input, this.input)
		} : $);
	}
	otherwise(t$1) {
		return this.state.matched ? this.state.value : t$1(this.input);
	}
	exhaustive(t$1 = L) {
		return this.state.matched ? this.state.value : t$1(this.input);
	}
	run() {
		return this.exhaustive();
	}
	returnType() {
		return this;
	}
	narrow() {
		return this;
	}
};
function L(t$1) {
	throw new W(t$1);
}

//#endregion
export { N, z };